// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__23YyA","messages":"Chat_messages__k6yoL","dateDivider":"Chat_dateDivider__1-hEc"};